<template>
    <div class="modal-details" >
        <div class="modal-details__container">
            <figure class="modal-details__img" :style="{ 'border-color': color }">
                <Image :image="image" :width="352" :height="198" :isLazy="false"></Image>
                <span class="mb-box__target-age" v-if="targetAge">{{ targetAge }}</span>
            </figure>
            <div class="modal-details__info">
                <h5 class="modal-details__header">
                    <IconSpeaker class="modal-details__speaker" @click="speechSynthesis(title)"></IconSpeaker>
                    <span class="modal-details__title">{{ title }}</span>
                </h5>
                <p class="modal-details__lead" v-html="lead"></p>
            </div>
            <IconClose class="modal-details__close close" @click="modalHandle"></IconClose>
        </div>
    </div>
</template>

<script>
import Image from "../elements/Image.vue";
import IconClose from "../elements/icons/IconClose.vue";
import IconSpeaker from "../elements/icons/IconSpeaker.vue";

export default {
    name: "ModalDetails",
    props: {
        image: {
            type: Object,
            required: true,
        },
        title: {
            type: String,
        },
        lead: {
            type: String,
        },
        color: {
            type: String,
        },
        targetAge: {
            type: String
        }
    },
    data() {
        return {
            showModal: false,
        };
    },
    components: {
        Image,
        IconClose,
        IconSpeaker
    },
    methods: {
        modalHandle() {
            this.$emit("toggleModalInfo");
        }
    }
};
</script>
